/**
 * Admin access helpers.
 * Source of truth: Firestore users/{uid}.status === 'admin' (and del !== 'yes').
 * Staff accounts are created/promoted in Settings by an existing admin.
 * REACT_APP_ADMIN_EMAILS is optional documentation only.
 */

export const ADMIN_STATUS = 'admin';

export const getAdminEmails = () => {
  const raw = process.env.REACT_APP_ADMIN_EMAILS || '';
  return raw
    .split(',')
    .map((email) => email.trim().toLowerCase())
    .filter(Boolean);
};

export const isAdminProfile = (profile) => {
  if (!profile || profile.del === 'yes') return false;
  return profile.status === ADMIN_STATUS;
};
